<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'إدارة الانشطة'" :to="{name: 'activities'}">إدارة الانشطة</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'activities.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i>
                                          بيانات إدارة الانشطة</h4>
                                    </div>
                                </div>
                            </div>
                             <div class="widget-content widget-content-area">
                               <form @submit.prevent="update()">
                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.program_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['program_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['program_date']">
                                                  {{ getErrors['program_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" :auto-load-root-options="true" @select="getStageCount" v-model="data.form.stage_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">كود البرنامج</label>
                                            <treeselect :options="budgets" :auto-load-root-options="true" @select="getHandleDataFromBudget" v-model="data.form.budget_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['budget_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['budget_id']">
                                                  {{ getErrors['budget_id'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                      <div class="col-md-8">
                                        <h6><a href="#" @click.prevent="addItem">اضافة بند</a></h6>
                                        <table class="table table-bordered">
                                          <thead>
                                            <tr class="text-center">
                                              <th colspan="5">تكلفة البرنامج الفعلية</th>
                                            </tr>
                                            <tr>
                                              <th>البند</th>
                                              <th>التكلفة </th>
                                              <th>الوصف</th>
                                              <th>ملاحظات</th>
                                              <th>#</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(i, k) in data.form.items" :key="k">
                                              <td style="width: 33%">
                                                <treeselect :options="items" :auto-load-root-options="true" @select="checkItemFound($event, k)" v-model="data.form.items[k].item_id" :multiple="false"/>
                                                 <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_id']">
                                                      {{ getErrors['items.'+k+'.item_id'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.items[k].item_cost" @change="clcTotalCost();" class="form-control" >
                                                <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_cost'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_cost']">
                                                      {{ getErrors['items.'+k+'.item_cost'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.items[k].item_description" class="form-control" >
                                                <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_description'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_description']">
                                                      {{ getErrors['items.'+k+'.item_description'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.items[k].item_notes" class="form-control" >
                                                <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_notes'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_notes']">
                                                      {{ getErrors['items.'+k+'.item_notes'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <a href="#" class="btn btn-danger" @click.prevent="deleteItem(data.form.items[k])" v-if="k != 0">X</a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                         <table class="table table-bordered mt-5">
                                          <thead>
                                            <tr>
                                              <th>الطالب</th>
                                              <th>حاضر </th>
                                              <th>غائب</th>
                                              <th>مستأذن</th>
                                              <th>المبلغ</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(s, k) in data.form.students" :key="k">
                                              <td style="width: 33%">
                                                <treeselect :options="students" :auto-load-root-options="true" @select="checkItemFound($event, k)" v-model="data.form.students[k].student_id" :multiple="false"/>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.item_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="radio" class="form-control" @change="clcAttends();" v-model="data.form.students[k].attend_status" value="حاضر">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.attent_status'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.attent_status']">
                                                      {{ getErrors['students.'+k+'.attent_status'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="radio" class="form-control" @change="clcAttends();" v-model="data.form.students[k].attend_status" value="غائب">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.attent_status'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.attent_status']">
                                                      {{ getErrors['students.'+k+'.attent_status'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                 <input type="radio" class="form-control" @change="clcAttends();" v-model="data.form.students[k].attend_status" value="مستأذن">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.attent_status'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.attent_status']">
                                                      {{ getErrors['students.'+k+'.attent_status'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                 <input type="text" class="form-control" @change="clcTotalFees();" v-model="data.form.students[k].amount">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.amount'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.amount']">
                                                      {{ getErrors['students.'+k+'.amount'][0] }}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div class="col-md-4">
                                         <div class="col-md-12">

                                             <label for="exampleFormControlInput12"> عدد طلاب المرحلة </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.student_stage_no"  placeholder="عدد طلاب المرحلة">
                                              <div class="invalid-feedback" :style="getErrors['student_stage_no'] ? 'display: block' : 'display: none;'"  v-if="getErrors['student_stage_no']">
                                                    {{ getErrors['student_stage_no'][0] }}
                                              </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12">

                                             <label for="exampleFormControlInput12"> عدد الحضور الفعلى </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.attend_no" @change="clcFee();" placeholder="عدد الحضور الفعلى">
                                              <div class="invalid-feedback" :style="getErrors['attend_no'] ? 'display: block' : 'display: none;'"  v-if="getErrors['attend_no']">
                                                    {{ getErrors['attend_no'][0] }}
                                              </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                           <label for="exampleFormControlInput12"> إجمالى الاشتراك </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" @change="clcTotalExp();" v-model="data.form.total_fees" placeholder="إجمالى الاشتراك">
                                              <div class="invalid-feedback" :style="getErrors['total_fees'] ? 'display: block' : 'display: none;'"  v-if="getErrors['total_fees']">
                                                    {{ getErrors['total_fees'][0] }}
                                              </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12"> إجمالى التكلفة  </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" @change="clcTotalExp();" v-model="data.form.total_cost" placeholder="إجمالى ">
                                              <div class="invalid-feedback" :style="getErrors['total_cost'] ? 'display: block' : 'display: none;'"  v-if="getErrors['total_cost']">
                                                    {{ getErrors['total_cost'][0] }}
                                              </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12">العجز  </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.expect_cost" placeholder="العجز  ">
                                              <div class="invalid-feedback" :style="getErrors['expect_cost'] ? 'display: block' : 'display: none;'"  v-if="getErrors['expect_cost']">
                                                    {{ getErrors['expect_cost'][0] }}
                                              </div>
                                          </div>
                                        </div>
                                      </div>




                                    </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                     <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'activities'}">
                                      <span>رجوع</span>
                                    </router-link>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import VueDatetimeJs from 'vue-datetime-js'
import 'vue-select/dist/vue-select.css';

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      gotData: false,
      teacher: '',
      items: [],
      teachers: [],
      stages: [],
      stage: '',
      data: {
        checker: false,
         form:{
            program_date: '',
            teacher_id: '',
            stages: [],
            period: '',
            description: '',
            place: '',
            student_stage_no: '',
            attend_no: '',
            fees: '',
            total_fees: '',
            total_cost: '',
            expect_cost: '',
            items: [
              {
                item_id: '',
                item_description: '',
                item_cost: ''
              }
            ]
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.getRequirements();
  },
  methods: {
    resetForm(){
      this.data.form = {
            program_date: '',
            teacher_id: '',
            budget_id: '',
            stages: [],
            attend_no: '',
            total_fees: '',
            total_cost: '',
            expect_cost: '',
            items: [
              {
                item_id: '',
                item_description: '',
                item_cost: '',
                item_notes: ''
              }
            ],
            students: [
              {
                student_id: '',
                amount: '0',
                attend_status: 'حاضر'
              }
            ]
        };
    },

      getInfo(){
        this.$baseApi.get('/activities/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = response.data.data.activity;
                this.students = response.data.data.studentsData;
                this.data.form.items = this.data.form.all_items;
                this.data.form.stages = this.data.form.all_stages;
                this.data.form.students = this.data.form.all_students;
                this.getDataOfSelect();

            }else if(response.data.code == 404){
                router.push('/activities');
            }else{
                alert(response.data.data.error);
                router.push('/activities');
            }
        });
      },
      checkItemFound(val, k){
      for (let index = 0; index < this.data.form.items.length; index++) {
         if(this.data.form.items[index].item_id == val.id && k != index){
          this.sweetAlert('البند مضاف بالفعل', 'warning');
          return;
         }
      }
    },
    clcAttends(){
      let total = 0;
      for (let index = 0; index < this.data.form.students.length; index++) {
        if(this.data.form.students[index].attend_status == 'حاضر'){
          total += 1;
        }
      }
      this.data.form.attend_no = total;
    },
    clcTotalFees(){
      let total = 0;
      for (let index = 0; index < this.data.form.students.length; index++) {
        total += Number(this.data.form.students[index].amount)
      }
      this.data.form.total_fees = total;
      this.clcTotalExp();
    },
    clcTotalCost(){
      let total = 0;
      for (let index = 0; index < this.data.form.items.length; index++) {
         total += Number(this.data.form.items[index].item_cost);
      }
      this.data.form.total_cost = total;
      this.clcTotalExp();
    },
    clcTotalExp(){
      if(this.data.form.total_cost != '' && this.data.form.total_fees){
        this.data.form.expect_cost = (Number(this.data.form.total_fees) - Number(this.data.form.total_cost));
      }
    },
     deleteItem(data){
      this.data.form.items.splice(this.data.form.items.indexOf(data), 1);
      this.clcTotalCost();
    },
    addItem(){
      this.data.form.items.push({
          item_id: '',
          item_description: '',
          item_cost: ''
      })
    },
     clcFee(){
      if(this.data.form.fees != '' && this.data.form.attend_no != ''){
        this.data.form.total_fees = (Number(this.data.form.fees) * Number(this.data.form.attend_no));
      }
     },
      update(){
          this.data.isRequested = true;
        this.$baseApi.patch('/activities/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
                localStorage.setItem('flash_message', response.data.messages[0]);
                router.push('/activities');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
      getStageCount(val){
        if(this.gotData == false){
          return;
        }
        this.$baseApi.get('/activities/' + this.$route.params.id + '/edit?count=1', {
                    params: {stages: this.data.form.stages}
                }).then((response)=>{
            if(response.data.code == 200){
              this.students = response.data.data.studentsData;
               this.data.form.students = response.data.data.students;
               this.data.form.student_stage_no = response.data.data.count;
               this.clcAttends();
               this.clcTotalFees();

            }else{
                alert(response.data.error.error);
            }
        });
      },
      getHandleDataFromBudget(node){
        this.gotData = false;
        this.$baseApi.get('/activities/' + this.$route.params.id + '/edit?type=budget&budget=' + node.id).then((response)=>{
            if(response.data.code == 200){
               let budget = response.data.data.budget;
               this.students = response.data.data.studentsData;
               this.data.form.students = response.data.data.students;
               this.data.form.student_stage_no = response.data.data.count;
               this.data.form.items = budget.all_items;
               this.data.form.stages = budget.all_stages;
               this.data.form.teacher_id = budget.teacher_id;
               this.clcTotalCost();
               setTimeout(() => {
                
                this.gotData = true;
               }, 3000);
            }
        });
      },
      getDataOfSelect(){
        this.$baseApi.get('/activities/' + this.$route.params.id + '/edit?pluck=1&stage=' + this.data.form.stage_id).then((response)=>{
            if(response.data.code == 200){
              let arr = [];
               let dd  = response.data.data.budgets;
               Object.keys(dd).forEach(key => {
                arr.push({id: dd[key], label: dd[key]});

              });
               
               this.budgets = arr;
               this.stages = response.data.data.stages;
               this.items = response.data.data.items;
              //  this.students = response.data.data.studentsData;
            }
        });
      },
      selected(node, instanceId){
        this.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
  watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.form.stage_id = newValue.id;
    },
    budget(newValue) {
      this.data.form.budget_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
